import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

/**
 * De laatste stap voordat een buddy iets wijzigt dat buiten zijn eigen gesprek
 * doorwerkt.
 *
 * Een buddy werkt normaal binnen één gesprek: wat hij daar invult, geldt daar.
 * Sinds hij zijn eigen roster inricht kan hij ook dingen aanraken die in de
 * personen- en opdrachtenadministratie blijven staan, en dat is een ander soort
 * handeling. Dit venster maakt dat verschil zichtbaar op het moment dat het
 * telt, in plaats van erop te vertrouwen dat hij het weet.
 *
 * Bewust één component: het gevolg is overal hetzelfde en hoort dus overal
 * hetzelfde te klinken. Alleen de eerste zin is per plek anders, want die
 * beschrijft de handeling zelf; het deel dat de belofte doet staat hieronder
 * vast. Drie eigen versies van dat tweede deel zijn drie kansen om er één te
 * vergeten.
 *
 * `actie` is één hele zin die zegt wat er gebeurt, bijvoorbeeld "Je wijzigt de
 * opdracht van Nick Wolter in de administratie." De handelingen verschillen te
 * veel om er één zinsbouw op te leggen: er wordt gewijzigd, maar ook toegevoegd
 * en gekoppeld.
 */
export function AdministratieWaarschuwing({
  open,
  actie,
  bezig,
  onBevestig,
  onAnnuleer,
}: {
  open: boolean;
  actie: string;
  bezig?: boolean;
  onBevestig: () => void;
  onAnnuleer: () => void;
}) {
  return (
    <AlertDialog onOpenChange={(o) => !o && onAnnuleer()} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Let op: dit blijft zo staan</AlertDialogTitle>
          <AlertDialogDescription>
            {actie} Dat geldt niet alleen voor dit gesprek: het blijft zo staan en een Admin ziet
            het voortaan zo op het personenscherm. Terugdraaien kan alleen een Admin.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={bezig}>Annuleren</AlertDialogCancel>
          <AlertDialogAction disabled={bezig} onClick={onBevestig}>
            Ja, definitief wijzigen
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
